import * as Sentry from "@sentry/react";
import { initialize } from "./utils/track";

if (
    process.env.PREACT_APP_SENTRY_DSN &&
    (process.env.NODE_ENV == 'production' || process.env.PREACT_APP_LOCAL_SENTRY)
) {
    // console.log(process.env.PREACT_APP_SENTRY_DSN)
    Sentry.init({
        dsn: process.env.PREACT_APP_SENTRY_DSN,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        tracePropagationTargets: ["localhost", /^https:\/\/raw\.githubusercontent\.com\//],
        // debug: true,
        // Performance Monitoring
        tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
        // Session Replay
        replaysSessionSampleRate: 0.1, // Record 10% of all sessions; increase for debugging.
        replaysOnErrorSampleRate: 1.0, // Always capture sessions where errors occur.
    });
}


// track initialize
initialize()
